export default __webpack_public_path__ + "static/media/1898.0875b025.png";